import theme from "@/theme";

enum HealthScoreRatingRange {
  HIGH = 60,
  MEDIUM = 40,
}

export function useHealthScoreRatingColour(healthScore: number) {
  let healthScoreRatingColour = "";

  if (healthScore > HealthScoreRatingRange.HIGH) {
    healthScoreRatingColour = theme.palette.accent1.main;
  } else if (healthScore >= HealthScoreRatingRange.MEDIUM) {
    healthScoreRatingColour = theme.palette.secondary.main;
  } else {
    healthScoreRatingColour = theme.palette.accent4.main;
  }

  return {
    healthScoreRatingColour,
  };
}
